import React from "react";
import { Link } from "react-router-dom";
import logo from "../assets/logo.png";

const LandingPage = () => {
  return (
    <div style={styles.container}>
      <img src={logo} alt="Cover" style={styles.image} />
      <div style={styles.buttonContainer}>
        <Link to="/know-more">
          <button style={styles.button}>Know More</button>
        </Link>
        {/*<Link to="/form">*/}
        {/*  <button style={styles.button}>Investor Form</button>*/}
        {/*</Link>*/}
      </div>
    </div>
  );
};

const styles = {
  container: {
    height: "100vh", // Full viewport height
    width: "100vw", // Full viewport width
    display: "flex",
    flexDirection: "column",
    justifyContent: "center", // Center vertically
    alignItems: "center", // Center horizontally
    textAlign: "center", // Center text and inline content
  },
  image: {
    maxHeight: "70%", // Constrain height to 70% of the viewport
    maxWidth: "70%", // Constrain width to 70% of the viewport
    objectFit: "contain", // Maintain aspect ratio
    marginBottom: "20px",
  },
  buttonContainer: {
    display: "flex",
    gap: "20px",
    justifyContent: "center",
  },
  button: {
    padding: "10px 20px",
    fontSize: "16px",
    backgroundColor:'#321E5D',
    color: "#fff",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
  },
};

export default LandingPage;
